import Vue from 'vue';
import App from './App.vue';
import Antd from 'ant-design-vue';
import router from './router';
import store from './store';
import './permission';
import 'ant-design-vue/dist/antd.css';
import '@/assets/css/reset.css';
import '@/assets/css/base.css';
import iconfont from 'components/base/iconfont.vue';
import VueLazyload from 'vue-lazyload';
import VueScrollLock from 'vue-scroll-lock';
import { hasPermission } from '@/utils/utils';

import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';

import * as ga from '@/assets/js/ga';

Vue.component('iconfont', iconfont);
import vuescroll from 'vuescroll';
import 'vuescroll/dist/vuescroll.css';
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
Vue.use(Viewer);

Vue.use(vuescroll);
Vue.use(VueLazyload);
Vue.use(VueScrollLock);

const _ga_id = process.env.VUE_APP_SENTRY_API === 'tianchi' ? 'G-MCQQ3S1KQ5' : 'G-V9YX34R852';

let head: any = document.querySelector('head') || {};

let script = document.createElement('script');
script.src=`https://www.googletagmanager.com/gtag/js?id=${_ga_id}`;
script.async = true;
head.appendChild(script);

script = document.createElement('script');
script.innerHTML = `window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', '${_ga_id}');`;
head.appendChild(script);

Vue.prototype.$sentry = Sentry;
Vue.prototype.$ga = ga;

Vue.prototype.$vuescrollConfig = {
  vuescroll: {
    mode: 'native'
  },
  scrollPanel: {
    scrollingX: true
  },
  bar: {
    delayTime: 500,
    onlyShowBarOnScroll: false,
    background: '#cecece',
    keepShow: false
  }
};
Vue.config.productionTip = false;
Vue.use(Antd);

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
});

setInterval(async () => {
  await store.dispatch('user/getUserInfo');
}, 60000);

if (/tianchi|hubble/.test(window.location.host)) {
  while (navigator.userAgent.indexOf('Chrome') === -1 && navigator.userAgent.indexOf('Safari') === -1) {
    alert('请使用Chrome或Safari浏览器');
  }
  const userInfo = localStorage.getItem('userInfo');
  let nickname = '';
  if (userInfo) {
    nickname = JSON.parse(userInfo)['nickname'];
  }
  let isDeveloper = ['史客', '晴天', '鲤鱼', '白犬', '加加', '豆豆', '无敌', '卷卷', '北海', '车厘子', '鲁班', '阿康'].some(name => {
    return new RegExp(name).test(nickname);
  });
  let isMobile = /mobile/i.test(navigator.userAgent);
  if (!isDeveloper && !isMobile) {
    var devToolWatcher = new Date();
    let tick = 0;
    devToolWatcher.toString = function() {
      // 首次打开页面也会触发
      tick++;
      if (tick > 1) {
        console.log('控制台打开了');
        window.open('about:blank', '_self');
      }
      return '';
    };
    //@ts-ignore
    window.say = window.console;
    //@ts-ignore
    window.say.log(devToolWatcher);
  }
}

Sentry.init({
  Vue,
  dsn:
    process.env.VUE_APP_SENTRY_API === 'tianchi'
      ? 'https://ad7dccf782244fa896842d3d4d583c79@sentry.sourcecodecap.com/4'
      : process.env.VUE_APP_SENTRY_API === 'pre'
        ? 'https://6b074f447a4941b08aad3d822bef8c18@sentry.sourcecodecap.com/5'
        : 'https://cc18eaf20dfe4f7f82f9584357975454@sentry.sourcecodecap.com/2', // ad7dccf782244fa896842d3d4d583c79/4
  integrations: [
    new Integrations.BrowserTracing({
      // routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    })
  ],
  tracesSampleRate: 1, // 发送错误的比例
  logErrors: process.env.VUE_APP_SENTRY_API === 'hubble' ? true : false,
  release: process.env.NODE_ENV === 'production' ? 'production@' + process.env.COMMITHASH : 'development@0.0.10',
  environment: process.env.NODE_ENV,
  enabled: process.env.VUE_APP_SENTRY_API !== 'hubble' ? true : false, // 只有预发布和线上开
  sendClientReports: false // 私有化部署不支持client_report错误类型
  // trackComponents: true
});
